import { InfoFieldGroupsType } from "./InfoFieldTypes";

export const PropertyInfoFieldGroups: InfoFieldGroupsType = {
  general: {
    fields: {
      location: {
        type: "geopoint",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      address: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      visitorAddress: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      postalAddress: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      city: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      municipality: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      municipalityNumber: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      gnr: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      bnr: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      snr: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      floors: {
        type: "array",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      totalParkingSpots: {
        type: "number",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      constructionYear: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: true,
        },
      },
      plotArea: {
        type: "number",
        defaultEnabled: true,
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      totalArea: {
        type: "number",
        defaultEnabled: true,
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      usageArea: {
        type: "number",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      builtArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      netArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      primaryArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      secondaryArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      rentableArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      jointArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      ownedArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      rentedArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      heatedArea: {
        type: "number",
        suffix: "m²",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      buildingOwner: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      architects: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      managementCompanies: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      insuranceCompanies: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      fireSafetyResponsibles: {
        type: "array",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      riskClass: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      fireClass: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      energyScore: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      heatingScore: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      protectionClass: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      maxPeopleAllowed: {
        type: "number",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      organizationNumber: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      organizationName: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
    },
    visibility: {
      landlordAdmin: true,
      landlord: true,
      tenantAdmin: true,
      tenant: true,
      entrepreneur: true,
    },
  },
  finance: {
    fields: {
      jointCost: {
        type: "number",
        suffix: "%",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      totalJointCost: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      marketValue: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      balanceSheetValue: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      grossYield: {
        type: "number",
        suffix: "%",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      purchaseDate: {
        type: "date",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      purchaseSum: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      initialLoan: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
      remainingLoan: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
    },
    visibility: {
      landlordAdmin: true,
      landlord: false,
      tenantAdmin: false,
      tenant: false,
      entrepreneur: false,
    },
  },
  note: {
    fields: {
      note: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
    },
    visibility: {
      landlordAdmin: true,
      landlord: true,
      tenantAdmin: false,
      tenant: false,
      entrepreneur: false,
    },
  },
};

